var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgViewCustomization = function SvgViewCustomization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 49,
    x: 9,
    y: 6,
    fill: "#fff",
    stroke: "var(--c-blue)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 15,
    y: 43,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 27,
    y: 43,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 39,
    y: 43,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 6,
    x: 9,
    y: 6,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    d: "M39.66 26.15A8.54 8.54 0 1 1 35.63 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-main-menu-num)",
    fillRule: "evenodd",
    d: "M43.18 15.72a2.45 2.45 0 0 0-3.48 0l-8.37 8.37A4.05 4.05 0 0 0 30 26.8V31h4.13a4.05 4.05 0 0 0 2.83-1.38l8.32-8.32a2.46 2.46 0 0 0 0-3.48l-2.1-2.1ZM34.06 29a2.08 2.08 0 0 0 1.43-.74l6.07-6.06-2.76-2.76-6.1 6.1c-.4.37-.66.87-.7 1.33V29h2.06Zm6.16-10.97 2.75 2.75.9-.89a.46.46 0 0 0 0-.65l-2.1-2.1a.46.46 0 0 0-.66 0l-.9.9Z",
    clipRule: "evenodd"
  })));
};
export default SvgViewCustomization;